import { render, staticRenderFns } from "./ProductEditPage.vue?vue&type=template&id=0eb8aa1f&"
import script from "./ProductEditPage.vue?vue&type=script&lang=js&"
export * from "./ProductEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports